import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type Screening = ApiSchemas['ScreeningPresenter']
export type ScreeningStatus = Screening['contactStatus']

export default {
  async list(options?: ApiSchemas['ListScreeningDto']) {
    return wrapEndpoint(() =>
      client.GET('/screening', {
        params: {
          query: options,
        },
      }),
    )
  },
  async updateStatus(uuid: string) {
    return wrapEndpoint(() =>
      client.PATCH('/screening/{uuid}/contact', {
        params: {
          path: {
            uuid,
          },
        },
      }),
    )
  },
}
